import {Controller} from "../../../mvc/decorators/class/controller";
@Controller("/")
export class FakeCtrl {}
